import { achOutForm } from './formModels/achOut.form';
import { mailCheckForm } from './formModels/mailCheck.form';
import { achOutMandatoryForm } from './formModels/achOutMandatory.form';
import { billPayForm } from './formModels/billPay.form';
import { accountantForm } from './formModels/accountant.form';
import { wireOutForm } from './formModels/wireOut.form';
import { wireOutFormMandatory } from './formModels/wireOutMandatory.form';

export const FORM_FIELDS = {
  ACH_ROUTING_NUMBER: 'achRoutingNumber',
  ACH_ACCOUNT_NUMBER: 'achAccountNumber',
  WIRE_ACCOUNT_NUMBER: 'wireAccountNumber',
  WIRE_ROUTING_NUMBER: 'wireRoutingNumber',
  BUSINESS_NAME: 'businessName',
  EMAIL: 'email',
  LINE_ONE: 'lineOne',
  LINE_TWO: 'lineTwo',
  CITY: 'city',
  ZIP_CODE: 'zipCode',
  STATE: 'state',
  FIRST_NAME: 'firstName',
  LAST_NAME: 'lastName',
  PHONE: 'phone',
  TIME_STAMP: 'timeStamp',
  NOTIFY_ON_PAYMENT: 'notifyOnPayment',
};

export const FORMS_TYPE_MAP = {
  MAIL_A_CHECK: mailCheckForm(),
  WIRE_OUT: wireOutForm(),
  WIRE_OUT_MANDATORY: wireOutFormMandatory(),
  ACH_OUT: achOutForm(),
  ACH_OUT_MANDATORY: achOutMandatoryForm(),
  BILL_PAY: billPayForm(),
  ACCOUNTANT: accountantForm(),
};

export const FORM_BLOCK_TYPES = {
  TRIGGER: 'trigger',
  SINGLE: 'single',
  MULTIPLE: 'multiple',
};

export const FORM_INPUT_TYPES = {
  TEXT: 'text',
  SELECT: 'select',
  CHECKBOX: 'checkbox',
};
